import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ArquicoCardFilterModule } from '../card-filter';
import { ArquivoTableModule } from '../table';
import { ArquivoUploadModalModule } from '../../upload/components/modal';

import { ArquivoCardViewComponent } from './arquivo-card-view.component';

@NgModule({
    imports: [
        SharedModule,
        ArquicoCardFilterModule,
        ArquivoTableModule,
        ArquivoUploadModalModule
    ],
    declarations: [
        ArquivoCardViewComponent
    ],
    exports: [
        ArquivoCardViewComponent
    ]
})
export class ArquivoCardViewModule { }
